export default __webpack_public_path__ + "static/media/other-file.ad37141a.png";